import { Content } from "pdfmake/interfaces";
import { date, loc, map } from "report/common/icon";
import layout from "report/common/layout";
import getTitle from "report/common/title";

const get = (t: any, name: string, lng: number, lat: number): Content[] => [
  getTitle(t("report.Report Details")),
  {
    table: {
      headerRows: 0,
      widths: ["auto", "*", "*"],
      body: [
        [
          {
            image: loc,
            width: 7.5,
            alignment: "right"
          },
          { text: t("report.Location Name"), opacity: 0.6 },
          name
        ],
        [
          {
            image: date,
            width: 7.5,
            alignment: "right"
          },
          { text: t("report.date"), opacity: 0.6 },
          new Date().toLocaleString()
        ],
        [
          {
            image: map,
            width: 7.5,
            alignment: "right"
          },
          { text: t("report.Lat Long"), opacity: 0.6 },
          `${lat}, ${lng}`
        ]
      ]
    },
    layout: layout(),
    fontSize: 8
  }
];

export default get;
